import PaymentMethodIcon from "@mui/icons-material/Money";
import PAYMENT_METHODS from "../../dictionaries/paymentMethods.json";
import BaseTag from "./BaseTag";

const PaymentMethodTag = (props) => (
  <BaseTag
    icon={<PaymentMethodIcon />}
    label={PAYMENT_METHODS[props.value]?.name}
  />
);

export default PaymentMethodTag;
